import { BaseType } from '../../../base/base-type';

export class EmploymentType extends BaseType {}
